import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import { getOrgCode } from '@/js/public'
import 'view-design/dist/styles/iview.css'
import { Button, Table, Layout, Sider, Modal, Menu, Icon, Message, Tooltip, Breadcrumb, BreadcrumbItem } from 'view-design'
import '@/assets/font/font.css'
import "babel-polyfill";
import Cookie from "js-cookie"
require('./api/mock.js')
Vue.component('Button', Button)
Vue.component('Table', Table)
Vue.component('Layout', Layout)
Vue.component('Sider', Sider)
Vue.component('Modal', Modal)
Vue.component('Menu', Menu)
Vue.component('Icon', Icon)
Vue.component('Message', Message)
Vue.component('Tooltip', Tooltip)
Vue.component('Breadcrumb', Breadcrumb)
Vue.component('BreadcrumbItem', BreadcrumbItem)

Vue.config.productionTip = false
Vue.prototype.$orgid = getOrgCode()
Vue.prototype.$Modal = Modal
Vue.prototype.$Message = Message
Vue.prototype.$cookie = Cookie

export const vue = new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
